import { render, staticRenderFns } from "./cerca.vue?vue&type=template&id=c73f273a&"
import script from "./cerca.vue?vue&type=script&lang=js&"
export * from "./cerca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports